<template>
  <div class="eqc-dialog-template dialog">
    <div class="head">
      <span>配置链接</span>
      <i
        class="eqf-no h2 close"
        @click="close()" />
    </div>
    <div class="content">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" style="margin-top:20px;">
        <el-form-item prop="val" label="链接配置">
          <el-radio v-model="formData.type" :label="1" @change="radioChange">
            <el-input style="width: 400px" placeholder="请输入链接地址，例：https://www.eqxiu.com/" v-model="formData.val"></el-input>
          </el-radio>
          <br />
          <el-radio v-model="formData.type" :label="2" @change="radioChange" v-if="data.platform === 1">
            创意云会员
          </el-radio>
        </el-form-item>
        <el-form-item prop="activityId" label="福利活动ID">
          <el-input style="width: 400px" placeholder="请填写福利活动ID，例：123456" v-model="formData.activityId"></el-input>
          <br />
          <div class="form-item-desc">填写福利活动ID后，用户可通过点击banner 触发福利活动</div>
        </el-form-item>
        <el-form-item label="app设置" v-if="data.platform !== 1">
          <el-row style="margin-bottom: 8px;" v-for="(app, index) in formData.apps" :key="index">
            <el-col :span="6">
              <el-form-item prop="date1" label="key" label-width="40px">
                <el-input size="mini" v-model="app.key"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="date2" label="value" label-width="80px">
                <el-input size="mini" v-model="app.value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1" v-if="index !== 0">
              <el-button size="mini" @click.prevent="removeApp(app)">删除</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="data.platform !== 1">
          <el-button size="mini" @click="addApp">新增配置</el-button>
        </el-form-item>

        <el-form-item label="小程序设置" v-if="data.platform !== 1">
          <el-row style="margin-bottom: 8px;" v-for="(pm, index) in formData.pms" :key="index">
            <el-col :span="6">
              <el-form-item prop="date1" label="key" label-width="40px">
                <el-input size="mini" v-model="pm.key"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="date2" label="value" label-width="80px">
                <el-input size="mini" v-model="pm.value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1" v-if="index !== 0">
              <el-button size="mini" @click.prevent="removePm(pm)">删除</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="data.platform !== 1">
          <el-button size="mini" @click="addPm">新增配置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="foot text-right">
      <el-button
        size="small"
        @click="close()">取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="commit"
      >确认</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formData: this.getFormData(),
      rules: {
        val: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.type !== 1) callback()
              if (value === '') callback()
              var strRegex = '^((https|http)://)?' +// (https或http或ftp):// 可有可无
                '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' + // ftp的user@  可有可无
                '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
                '|' + // 允许IP和DOMAIN（域名）
                '(localhost)|' +// 匹配localhost
                '([\\w_!~*\'()-]+\\.)*' + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
                '\\w+\\.' + // 一级域名 -英文或数字  加上.
                '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
                '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
                '((/?)|' + // url无参数结尾 - 斜杆或这没有
                '(/[\\w_!~*\'()\\.;?:@&=+$,%#-]+)+/?)$'// 请求参数结尾- 英文或数字和[]内的各种字符
              var reg = new RegExp(strRegex, 'i')// i不区分大小写
              reg.test(value) ? callback() : callback(new Error('请输入正确的链接'))
            },
            trigger: 'change'
          }
        ]
      }

    }
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    close: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    commit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.close(this.formData)
      })
    },
    checkKeydown ($el) {
      $el.preventDefault()
      if ($el.keyCode === 13) {
        this.commit()
        return false
      }
    },
    radioChange (value) {
      this.$refs.ruleForm.validateField('val')
    },
    getType () {
      if (this.data.val && typeof this.data.val !== 'string') {
        return this.data.val.type
      }
      return 1
    },
    getFormData () {
      if (typeof this.data.val === 'string') {
        const initData = {
          type: 1,
          val: this.data.val,
          activityId: ''
        }
        if (this.data.platform !== 1) {
          initData.apps = [
            {
              key: 'target',
              value: ''
            }
          ]
          initData.pms = [
            {
              key: 'target',
              value: ''
            }
          ]
        }
        return initData
      } else if (this.data.platform === 1) {
        return { activityId: '', ...this.data.val }
      } else {
        return {
          activityId: '',
          ...this.data.val,
          apps: this.data.val.apps || [
            {
              key: 'target',
              value: ''
            }
          ],
          pms: this.data.val.pms || [
            {
              key: 'target',
              value: ''
            }
          ]
        }
      }
    },
    removeApp (item) {
      let index = this.formData.apps.indexOf(item)
      if (index !== -1) {
        this.formData.apps.splice(index, 1)
      }
    },
    addApp () {
      if (this.formData.apps.length >= 8) return
      this.formData.apps.push({
        key: '',
        value: ''
      })
    },
    removePm (item) {
      let index = this.formData.pms.indexOf(item)
      if (index !== -1) {
        this.formData.pms.splice(index, 1)
      }
    },
    addPm () {
      if (this.formData.pms.length >= 7) return
      this.formData.pms.push({
        key: '',
        value: ''
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  .eqc-dialog-template {
    width: 700px;
  }

  .head {
    border-bottom: 1px solid #ccd5db;
    background-color: #fff;
    font-size: 16px;
    color: #333;
    padding: 17px 20px;
    min-height: 21.42857143px;
    background-color: #f7f7f7;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    .close {
      float: right;
      cursor: pointer;
    }
    .close:hover {
      color: #666666;
    }
  }

  .foot {
    padding: 10px 20px;
  }

  .content {
    padding: 0 20px;
    padding-top: 10px;
    .form-item-desc {
      color: #666;
    }
  }
</style>
